import React from "react";
import {NavLink} from "react-router-dom";

interface ProfileOptionsProps {
    open: boolean;
    onLogout: () => void;
}

export const ProfileOptions: React.FC<ProfileOptionsProps> = ({open, onLogout}) => {
    return (
        <div className="profile-options">
            {open && (
                <div className="profile-block">
                    <NavLink style={{boxShadow: 'none'}} className="profile" to="/personal-profile">
                        <span>Личный профиль</span>
                    </NavLink>
                    <span
                        className="exit"
                        onClick={onLogout}
                    >Выйти
                    </span>
                </div>
            )}
        </div>
    );
};
